import React from 'react';
import { useTranslation } from 'react-i18next';

export default function TripHeader({ trip, tripDays, totalCost }) {
    const { t, i18n } = useTranslation();
    const locale = i18n.language === 'en' ? 'en-US' : 'it-IT';
    const currency  = trip.currency || '€';
    const hasBudget = trip.budget != null && trip.budget !== 0;
    const diff      = hasBudget ? trip.budget - totalCost : 0;
    const statColor = hasBudget && totalCost > trip.budget
        ? 'text-red-500 dark:text-red-400'
        : 'text-emerald-600 dark:text-emerald-400';

    return (
        <div className="bg-gradient-to-br from-primary-50 via-white to-purple-50 dark:from-gray-800 dark:via-gray-800 dark:to-gray-800/60 rounded-2xl p-6 border border-primary-200 dark:border-gray-700">
            <div className="flex items-start justify-between gap-4 mb-6">
                <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">
                    {trip.image} {trip.name}
                </h1>
                {trip.isPrivate && (
                    <span className="badge bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-300 whitespace-nowrap">
                        {t('tripHeader.private')}
                    </span>
                )}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                <div>
                    <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1">{t('tripHeader.destination')}</p>
                    <p className="text-base font-medium text-gray-900 dark:text-gray-100">{trip.destination}</p>
                </div>
                <div>
                    <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1">{t('tripHeader.period')}</p>
                    <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                        {new Date(trip.startDate).toLocaleDateString(locale)} — {new Date(trip.endDate).toLocaleDateString(locale)}
                    </p>
                </div>
                <div>
                    <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1">{t('tripHeader.duration')}</p>
                    <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                        {t('tripHeader.days', { count: tripDays })}
                    </p>
                </div>
            </div>

            {hasBudget && (
                <>
                    <hr className="border-primary-200 dark:border-gray-700 my-4" />
                    <div className="grid grid-cols-3 gap-4">
                        {[
                            { label: t('tripHeader.budgetPlanned'), value: `${currency}${trip.budget}`, color: 'text-gray-900 dark:text-gray-100' },
                            { label: t('tripHeader.budgetEstimated'), value: `${currency}${totalCost}`, color: statColor },
                            { label: t('tripHeader.difference'), value: `${diff < 0 ? '' : '+'}${currency}${diff}`, color: statColor },
                        ].map(({ label, value, color }) => (
                            <div key={label}>
                                <p className="text-xs text-gray-500 dark:text-gray-400 mb-1">{label}</p>
                                <p className={`text-xl font-bold ${color}`}>{value}</p>
                            </div>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}
